<template>
  <v-dialog :value="true" persistent max-width="290" >
    <v-card>
      <v-card-title class="v-c-t parand">
        ویرایش
      </v-card-title>
      <v-card-text class="parand"
        >ویرایش عنوان این وظیفه:
        <v-text-field v-model="taskTitle" @keyup.enter="saveTask" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="parand" text @click="$emit('close')">
          لغو
        </v-btn>
        <v-btn
          class="parand"
          color="success"
          text
          @click="saveTask"
          :disabled="taskTitleInvalid"
        >
          ذخیره
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["task"],
  data() {
    return {
      taskTitle: null,
    };
  },
  computed: {
    taskTitleInvalid() {
      return !this.taskTitle || this.taskTitle === this.task.title;
    },
  },
  methods: {
    saveTask() {
      if (!this.taskTitleInvalid) {
        let payload = {
          id: this.task.id,
          title: this.taskTitle,
        };
        this.$store.dispatch("updateTaskTitle", payload);
        this.$emit("close");
        this.$vuetify.goTo(0, {duration: 0})
      }
    },
  },
  mounted() {
    this.taskTitle = this.task.title;
  },
};
</script>

<style lang="sass" scoped>
.parand
  font-family: "Parand"
.v-c-t
  font-size: 1rem
</style>
